import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateAIToggleAction, updateAppleLoginToggleAction } from "../../actions/settings";
import ToggleSwitch from "../../components/toogle/ToggleSwitch";

export default function AppSetting({ showAI, appleLogin }) {
  const dispatch = useDispatch();
  const [isAIEnabled, setIsAIEnabled] = useState(Number(showAI) === 1);
  const [isAppleLoginEnabled, setIsAppleLoginEnabled] = useState(Number(appleLogin) === 1);

  useEffect(() => {
    setIsAIEnabled(Number(showAI) === 1);
  }, [showAI]);

  useEffect(() => {
    setIsAppleLoginEnabled(Number(appleLogin) === 1);
  }, [appleLogin]);

  const handleAIToggle = (value) => {
    setIsAIEnabled(value);
    dispatch(updateAIToggleAction({ showAI: value ? 1 : 0 }));
  };

  const handleAppleLoginToggle = (value) => {
    setIsAppleLoginEnabled(value);
    dispatch(updateAppleLoginToggleAction({ showAppleLogin: value ? 1 : 0 }));
  };

  return (
    <div className="form-group form-margin">
      <div className="row align-items-center">
        <div className="col-lg-8 col-md-8 col-sm-12">
          <label className="col-form-label edit-info mb-0">AI feature</label>
          <div className="input-text">
            {isAIEnabled ? "Turned on" : "Turned off"}
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 mt-3 mt-md-0 text-md-end">
          <ToggleSwitch isOn={isAIEnabled} setIsOn={handleAIToggle} />
        </div>
      </div>
      <div className="row align-items-center mt-4">
        <div className="col-lg-8 col-md-8 col-sm-12">
          <label className="col-form-label edit-info mb-0">Apple login</label>
          <div className="input-text">
            {isAppleLoginEnabled ? "Turned on" : "Turned off"}
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 mt-3 mt-md-0 text-md-end">
          <ToggleSwitch isOn={isAppleLoginEnabled} setIsOn={handleAppleLoginToggle} />
        </div>
      </div>
    </div>
  );
}
